import { createFeatureSelector, createSelector } from '@ngrx/store';
import { environment } from '../../../../environments/environment';
import { initialState, profileFeatureKey, ProfileState } from '../reducer/profile.reducer';

const selectProfileFeatureUnsafe = createFeatureSelector<ProfileState | undefined>(profileFeatureKey);

export const selectProfileFeature = createSelector(selectProfileFeatureUnsafe, state => state ?? initialState);

export const selectError = createSelector(selectProfileFeature, state =>
  state.error === null ? null : environment.errorMessage
);

export const selectProfile = createSelector(selectProfileFeature, state => state.profile);

export const selectIsSaving = createSelector(selectProfileFeature, state => state.isSaving);

export const selectPatientZipCode = createSelector(selectProfile, profile => {
  const postalCode = profile?.residentialAddress?.postalCode;
  return postalCode === undefined ? null : postalCode;
});

export const selectFullProfile = createSelector(selectProfileFeature, state => state.fullProfile);

export const selectIsLoading = createSelector(selectProfileFeature, state => state.isLoading);
